// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","toggle":"medkit__Toggle__toggle","toggle__switch":"medkit__Toggle__toggle__switch"};